/**
 * @author Ariel
 * @description 标签管理页面配置
 * @Date 2023/08/03
 */
import React from "react";
import { component_tool } from "../../../tool";
let { WizDataTable, WizButton } = component_tool

let componentName = 'label';

const columns = (e) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '标签名称',
      name: 'name',
      searchItem: {},
      tableItem: {},
    },
    {
      title: '标签编码',
      name: 'code',
      searchItem: {},
      tableItem: {},
    },
    {
      title: '标签分类',
      name: 'categoryName',
      tableItem: {},
    },
    {
      title: '标签状态',
      name: 'state',
      searchItem: { type: 'select' },
      tableItem: {},
      dict: [
        { code: 0, codeName: '无效' },
        { code: 1, codeName: '有效' }
      ]
    },
    {
      title: '标签来源',
      name: 'source',
      searchItem: { type: 'select' },
      tableItem: {},
      dict: [
        { code: 0, codeName: '系统' },
        { code: 1, codeName: '第三方' }
      ]
    },
    {
      title: '标签分类',
      name: 'categoryName',
      searchItem: {},
    },
    {
      title: '标签人数',
      name: 'studentNum',
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip={text}
              onClick={() => {
                e.jumpPage && e.jumpPage(
                  'push',
                  '/biz/label/labelUser',
                  record
                )
              }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      },
    },
    {
      title: '是否撕除标签',
      name: 'tear',
      tableItem: {},
      dict: [
        { code: 0, codeName: '否' },
        { code: 1, codeName: '是' }
      ]
    },
    {
      title: '创建人',
      name: 'fullName',
      tableItem: {},
    },
    {
      title: '创建时间',
      name: 'createTime',
      tableItem: {},
    },
    {
      title: '更新时间',
      name: 'updateTime',
      tableItem: {},
    },
  ]
}



const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(e),
        searchBarProps: {
          buttonSort: ['add', 'delete', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/biz/label/add'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        siderBarProps: {
          key: "orgNodeTree",
          searchKey: "categoryId",
          params: {}
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['look', 'update', 'featureContent'],
        rowOperateView: [
          {
            key: 'look',
            custom: true,
            params: { children: '查看' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/biz/label/look'
              }
            }
          },
          {
            key: 'update',
            custom: true,
            params: { children: '编辑' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/biz/label/update'
              }
            }
          },
          {
            key: 'featureContent',
            custom: true,
            params: { children: '推荐内容' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/biz/label/featureContent'
              }
            }
          },
        ],
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  treeData: {
    path: `questionType/normalNodeList`,
    payload: {
      key: `questionType@treeData`,
      apiParams: { type: 18 }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
